"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.unionBy = void 0;
require("../../core");
const unionBy = (listA, listB, property) => {
    return [...listA, ...listB].filter(((set) => (o) => set.has(o[property]) ? false : set.add(o[property]))(new Set()));
};
exports.unionBy = unionBy;
//# sourceMappingURL=unionBy.js.map